import {
  ApplicationDetails,
  ApplicationMetrics
} from '../types/Applications';
import ApiClient from './ApiClient';



export class ApplicationService {
  private API_URL = process.env.REACT_APP_CAMPAIGN_API_URL ?? "";

  private apiClientInstance = new ApiClient(this.API_URL);
  private apiClient = this.apiClientInstance.getClient();

  public async getApplicationMetrics(organizationId: string, campaignId: string): Promise<ApplicationMetrics> {
    const response = await this.apiClient.get(
      `/${organizationId}/campaigns/${campaignId}/application/metrics`
    );
    return response.data;
  }

  public async getApplication(organizationId: string, campaignId: string): Promise<ApplicationDetails> {
    const response = await this.apiClient.get(
      `/${organizationId}/campaigns/${campaignId}/application`
    );
    return response.data;
  }

  public async updateApplication(organizationId: string, campaignId: string, applicationData: ApplicationDetails): Promise<ApplicationDetails> {
    try {
      const response = await this.apiClient.post(
        `/${organizationId}/campaigns/${campaignId}/application`,
        applicationData
      );

      return response.data;
    } catch (error) {
      console.error('Error updating application details:', error);
      throw error;
    }
  }
}

export default ApplicationService;
